export class TokenRepository {
    token: string | undefined;

    write(token?: string): void {
        this.token = token;
    }

    read(): string | undefined {
        return this.token;
    }
}

export const tokenRepository = new TokenRepository();
